import { startOfDay } from 'date-fns';

import { CashFlowConfig } from '@ndvr/portfolio-api';

import { parseNumberStr } from 'utils/number-utils';

import { getNextFactorOccurrence } from '../../utils/factor-date-frame-utils';

export interface NextWithdrawal {
    date: string;
    amount: number;
}

export const getNextCashFlowOccurrence = (config: CashFlowConfig, today = startOfDay(new Date())): string | undefined =>
    getNextFactorOccurrence(config.factorDateFrame, today);

export const getNextWithdrawal = (
    configs: CashFlowConfig[],
    today = startOfDay(new Date()),
): NextWithdrawal | undefined => {
    const upcoming = configs
        .map((config) => ({ config, date: getNextCashFlowOccurrence(config, today) }))
        .filter((item): item is { config: CashFlowConfig; date: string } => item.date !== undefined)
        .sort((a, b) => a.date.localeCompare(b.date));
    const nextDate = upcoming[0]?.date;

    if (!nextDate) return undefined;

    return {
        date: nextDate,
        amount: upcoming
            .filter(({ date }) => date === nextDate)
            .reduce((total, { config }) => total + parseNumberStr(config.amount), 0),
    };
};
